import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { IInitialIEPInfo } from '../Models/IInitialIEPInfo';

@Injectable()
export class SelectedStudentService {
  private _initialIepInfo = new BehaviorSubject < IInitialIEPInfo > ({
    id: 0,
    localStudentId: '',
    datePermissionRevoked: null,
    dateScanned: null,
    enteredBy: '',
    entryDate: null,
    identifiedAsSPEDDate: null,
    initialConsentDate: null,
    initialEvalDate: null,
    initialIepDate: null,
    lastEvalDate: null,
    mostRecentLaserficheDocumentId: 0,
    mostRecentLaserficheDocumentUpdatedBy: null,
    mostRecentLaserficheDocumentUpdatedOn: null,
    primaryDisabilityCode: '',
    scannedToStudentFolderNo: false,
    scannedToStudentFolderYes: false,
    spedEntryDate: null,
    spedIdentifierName: '',
    spedIdentifierDescription: '',
    spedIdentifierId: 0,
    spedIdentifierIdString: '',
    spedPermissionRestored: false,
    spedPermissionRevoked: false,
    withdrawlReason: '',
    writtenRequestReceivedNo: false,
    writtenRequestReceivedYes: false,
    updatedOn: null,
    updatedBy: '',
    updatedIP: ''
  })

  getInitialIepInfo(): Observable<IInitialIEPInfo> {
    return this._initialIepInfo;
  }

  setInitialIepInfo(info: IInitialIEPInfo) {
    this._initialIepInfo.next(info);
  }
}
